"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SORTABLE_GET_SMS_ENVIADOS_COLUMNS_MAP = void 0;
exports.SORTABLE_GET_SMS_ENVIADOS_COLUMNS_MAP = {
    id: 'id',
    origen: 'sender',
    destino: 'receiver',
    envio_a_plataforma: 'clienteenvio',
    envio_a_telco: 'senttime',
    recibido_destino: 'receivedtime',
    mensaje: 'msg',
    estado: 'status',
};
